/*
 * 戒导航 · 上传模块（jiedh/upload）前台初始化
 * =============================================================================
 * 职责（详见 doc/输入框富文本编辑器设计方案.md §8）：
 *   让富文本编辑器识别 fof/upload 的 [upl-image-preview …] 自闭合 BBCode ——
 *   上传图片后编辑器内直接显示图片，而不是 BBCode 原文；
 *   提交时再**原样**序列化回 BBCode，落库格式与改造前完全一致。
 *
 * 注意：initializers.add() 的 name 必须与扩展 ID 对应（本包 ID 为 jiedh/upload）。
 * 注册动作本身与执行顺序无关：三腿都走字符串目标的 extend()，
 * 由 flarum.reg.onLoad 延迟解析 —— fof/rich-text 的模块无论何时加载都能接上。
 */
import app from 'flarum/forum/app';
import { registerUplImagePreview } from './registerUplImagePreview';
app.initializers.add('jiedh-upload', () => {
  registerUplImagePreview();
});